import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { MODAL_TYPES } from '@alphapoint/apex-web/lib/redux/actions/modalActions';
import { orderFormTypes } from '@alphapoint/apex-web/lib/constants/sendOrder/orderFormTypes';
import { placeOrder } from '@alphapoint/apex-web/lib/redux/actions/orderEntryActions';
import { showSnack } from '@alphapoint/apex-web/lib/redux/actions/snackbarActions';
import { subscribeToLevel1 } from '@alphapoint/apex-web/lib/redux/actions/level1Actions';
import { subscribeToLevel2 } from '@alphapoint/apex-web/lib/redux/actions/level2Actions';
import { setInstrument } from '@alphapoint/apex-web/lib/redux/actions/instrumentActions';
import ConfirmOrderModalComponent from './ConfirmOrderModalComponent';
import modalDecorator from '@alphapoint/apex-web/lib/hocs/modalDecorator';

const streamingForm = 'StreamingForm';

const mapDispatchToProps = (dispatch) => {
  return {
    resetForm: () => dispatch(reset(streamingForm)),
    setInstrument: (payload) => {
      dispatch(setInstrument(payload.instrumentId));
      // resubscribe to level2
      dispatch(subscribeToLevel1(payload.instrumentId));
      dispatch(subscribeToLevel2(payload.instrumentId));
      localStorage.setItem('selectedInstrumentId', payload.instrumentId);
    },
    confirmReport: (payload) => {
      dispatch(placeOrder(orderFormTypes.default, payload)).then((res) => {
        if (res.result === false) {
          dispatch(
            showSnack({
              id: 'placeOrderError',
              text: res.errormsg || res.detail,
              type: 'warning',
            }),
          );
        }
      });
    },
  };
};

const container = connect(null, mapDispatchToProps)(ConfirmOrderModalComponent);

export default modalDecorator({ name: MODAL_TYPES.CONFIRM_ORDER_REPORT })(container);
